import $ from 'jquery';
import spinner from '../spinner.js';
import Cookies from './../libs/tomcat-cookies.js';
import notifications from './../notifications.js';
import togglePassword from './../toggle-password.js';
import config from './../config.js';
import login from './../login.js';
import accountInfo from './../account-info.js';
import pesel from './pesel.js';
import Intent from './../utils/intent.js';
import {
	rootDomain
} from './../store/cookies.js';
import {
	replace
} from './../store/history.js';
import pixelTracking from './../pixel-tracking/pixel-tracking.js';
import { fetchJson } from './../core/ajax-json.js';

let $signUp = {};
let $signUpBasic;
let $signUpDetails;
let $mobileVerification;
let $mobileVerificationButton;
let $signUpBasicForm;
let $signUpDetailsForm;
let $birthDate;
let $gender;
let $countryCodeField;
let $localization;
let $voucher;
let countryIsoCode = config.locale.substr(config.locale.length - 2).toLowerCase();
const player = {};
let $PhNumber;
let $callingCode;
let currentMobile = null;
let isMobileVerified = null;
const ERROR_CLASS = 'input-wrap__error';
const VALID_CLASS = 'is-valid';
const MIN_LENGTH_USERNAME = 5;
const MAX_LENGTH_USERNAME = 16;
const MIN_LENGTH_EMAIL = 5;
const MAX_LENGTH_EMAIL = 50;
const MIN_LENGTH_PASSWORD = 6;
const MAX_LENGTH_PASSWORD = 15;
const MIN_LENGTH_NAMES = 2;
const MAX_LENGTH_NAMES = 20;
const MIN_LENGTH_ADDRESS = 2;
const MAX_LENGTH_ADDRESS = 50;
const MIN_LENGTH_CITY = 2;
const MAX_LENGTH_CITY = 30;
const MAX_LENGTH_COUNTRY_CODE = 7;
const DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE = 'content-dynamic-error';
const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;
const currentDay = new Date().getDate();

//Save the selected values, so they can be restored after clicking T&C.
let selectedValues = {
	year: 0,
	month: 0,
	day: 0,
	gender: 0,
	country: null,
	currency: null
};


/**
 * will display error message in a span under the field
 * @param field, input having an error
 */
function displayError(field, customError) {
	const $inputField = $(field);
	const $inputFieldParent = $inputField.parent();
	let errorMessage = customError ? $inputFieldParent.data(customError) : $inputFieldParent.data('content-error');
	if ($inputFieldParent.data('content-dynamic-error') !== undefined) {
		errorMessage = $inputFieldParent.data('content-dynamic-error');
	}
	$inputFieldParent.find('.js-input-error-display').html(errorMessage);
}

/**
 * Add/Remove error class on invalid input field
 * @param $input field
 */
function markInvalid($input, customError) {
	$input.addClass(ERROR_CLASS).removeClass(VALID_CLASS);
	displayError($input, customError);
}

function getMobileNumber($code, $mobile) {
	const callingCode = $code.val();
	const mobile = $mobile.val();
	return `${callingCode}${mobile}`;
}

function checkUnique(field, flow, value) {
	const $field = $(field);
	const $inputParent = $($field).parent();
	const $container = $inputParent.closest('.js-step-container');
	const val = value || $field.val();
	spinner.show($container);

	const checkUniquePromise = $.ajax({
		async: true,
		type: 'GET',
		url: `/${flow}${val}`,
		dataType: 'json',
		contentType: 'application/json; charset=utf-8'
	}).done((data) => {
		if (data.status === 'SUCCESS') { /* && data.result && data.result.value*/
			player[$field.attr('map')] = $field.val();
			$field.removeClass(ERROR_CLASS).addClass(VALID_CLASS);
			$inputParent.removeData(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE);
		} else {
			$field.removeClass(VALID_CLASS).addClass(ERROR_CLASS);
			$inputParent.data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE, data.errorDescription);
			markInvalid($field);
			displayError($field);
			// notifications.showNotification(`Error: ${flow} FAILED: ${data.errorCode}`, 'red', true);
		}
	}).fail((jqXHR, textStatus, errorThrown) => {
		console.error(jqXHR, textStatus, errorThrown);
		displayError($field);

		// notifications.showNotification(`Error: ${flow} FAILED${errorThrown}`, 'red', true);
	}).always(() => {
		spinner.hide($container);
	});

	return checkUniquePromise;
}

/**
 * Removes error message from span under field
 * @param field to clean
 */
function removeErrorMessage(field) {
	const $inputField = $(field);
	const $inputFieldParent = $inputField.parent();
	$inputFieldParent.find('.js-input-error-display').text('');
}

function markValid($input) {
	$input.addClass(VALID_CLASS).removeClass(ERROR_CLASS);
	removeErrorMessage($input);
}

/**
 *
 * @param $field, form input field - jQuery object
 * @param minLength, usually from constants
 * @param maxLength, usually from constants
 * @returns {boolean}
 */
function checkFieldLength($field, minLength, maxLength) {
	return ($field.val().length <= maxLength && $field.val().length >= minLength);
}

/**
 *
 * @param $field, form input field - jQuery object
 * @returns {*} - Promise from ajax call in checkUnique
 */
function checkUniqueUsername($field) {
	return checkUnique($field, 'rest/register/username/');
}

function checkUniqueEmail($field) {
	return checkUnique($field, 'rest/register/email/');
}

function adjustPhoneNumber(phoneNumber) {
	return phoneNumber.replace(/^[0]+/, '');
}

function checkUniquePhoneNumber($field1, $field2) {
	const val = $field1.val();
	const str = (`rest/register/phone/${val}/`);
	return checkUnique($field2, str, adjustPhoneNumber($field2.val()));
}

/**
 * Returns true if value contains letters and numbers
 * @param value, input field value
 * @returns {boolean}
 */
function notOnlyLetters(value) {
	let i;
	let x;
	let code;
	let valid = true;
	let hasAsciiLetter = false;
	let hasNumber = false;

	for (i = 0, x = value.length; i < x; i += 1) {
		code = value.charCodeAt(i);
		// ASCII printable characters without DEL and SPACE http://www.ascii-code.com/
		if (code < 33 || code > 126) {
			valid = false;
			break;
		}
		if (!hasAsciiLetter && ((code < 91 && code > 64) || (code < 123 && code > 96))) {
			hasAsciiLetter = true;
		} else if (!hasNumber && code > 47 && code < 58) {
			hasNumber = true;
		}
	}
	if (!hasAsciiLetter) {
		valid = false;
	}
	if (valid && !hasNumber) {
		valid = false;
	}
	return valid;
}

function isOnlyLettersSpacesDashes(value) {
	/* refactored to follow common guidelines and linting rules
	saving old code until confirmed ok //Sunny jan 2017*/
	const L = value.length;
	let valid = true;
	for (let i = 0; i < L; i += 1) {
		// for (i = 0, x = value.length; i < x; i += 1) {
		const val1 = (value.charCodeAt(i) >= 0 && value.charCodeAt(i) < 32);
		const val2 = (value.charCodeAt(i) > 32 && value.charCodeAt(i) < 44);
		const val3 = (value.charCodeAt(i) > 45 && value.charCodeAt(i) < 65);
		const val4 = (value.charCodeAt(i) > 90 && value.charCodeAt(i) < 97);
		const val5 = (value.charCodeAt(i) > 122 && value.charCodeAt(i) < 128);
		const val6 = !isSpacesValid(value);
		const hasNonvalidChars = (val1 || val2 || val3 || val4 || val5 || val6);
		if (hasNonvalidChars) {
			valid = false;
		}
	}
	return valid;
}

// REGEX VALIDATIONS
function customEmailValidation(value) {
	return (/^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/).test(value);
	// return (/^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9\-]+)*@[A-Za-z0-9\-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/).test(value);
}

function isSpacesValid(value) {
	return !(/(^\s|\s\s+|\s$)/g).test(value);
}

function isOnlyNumbersAndLetters(value) {
	return (/^[a-zA-Z\d]+$/).test(value);
}

function isOnlyNumbers(value) {
	return (/^[\d]+$/).test(value);
}

function isGenderValid($field) {
	let isValid = false;
	if (Number($field.val()) > 0) {
		markValid($field);
		isValid = true;
	} else {
		markInvalid($field);
	}
	return isValid;
}

function areSecondStepInputFieldsValid() {
	return $signUpDetailsForm.find('input').length === $signUpDetailsForm.find(`input.${VALID_CLASS}`).length;
}

function areSecondStepSelectFieldsValid() {
	return $signUpDetailsForm.find('select').length === $signUpDetailsForm.find(`select.${VALID_CLASS}`).length;
}

/**
 * Returns true if all input fields have a VALID_CLASS
 * @returns {boolean}
 */
function isFirstStepFormValid() {
	return $signUpBasicForm.find('input').length === $signUpBasicForm.find(`input.${VALID_CLASS}`).length;
}

function isSecondStepFormValid() {
	let formValid = false;
	const inputFieldsValid = areSecondStepInputFieldsValid();
	const selectFieldsValid = areSecondStepSelectFieldsValid();

	if (inputFieldsValid && selectFieldsValid) {
		formValid = true;
	}
	return formValid;
}

function enableContinueButton() {
	$signUp.find('#continue').attr('disabled', false);
}

function disableContinueButton() {
	$signUp.find('#continue').attr('disabled', true);
}

function enableOpenAccountButton() {
	$signUp.find('#open-account-button').attr('disabled', false);
}

function disableOpenAccountButton() {
	$signUp.find('#open-account-button').attr('disabled', true);
}

function populatePlayerObject() {
	const $elementsInSecondStep = $signUpDetailsForm.find('input, select');

	$elementsInSecondStep.each(function nameToBeLintvalid() {
		const mappingName = $(this).attr('map');
		let paramValue = $(this).val();
		if (mappingName) {
			if (mappingName === 'gender') {
				paramValue = paramValue === '1' ? 'MALE' : 'FEMALE';
			}
			player[mappingName] = paramValue;
		}
	});

	// TODO add deviceId generator and save in localStorage
	player.deviceId = 'mydevice1';
}

/**
 * Validates form fields in step 2 of registration
 * @param field
 * @returns {object}
 */
function validate(field) {
	return new Promise((resolve) => {
		const $field = $(field);
		let fieldValid = false;

		if ($field.attr('name') === 'PARAM_USR_NAME') {
			if (checkFieldLength($field, MIN_LENGTH_USERNAME, MAX_LENGTH_USERNAME) && isOnlyNumbersAndLetters($field.val())) {
				checkUniqueUsername($field).done((data) => {
					if (data.status === 'SUCCESS') {
						markValid($field);
						fieldValid = true;
					} else {
						markInvalid($field);
					}
					resolve(fieldValid);
				});
			} else {
				markInvalid($field);
				resolve(fieldValid);
			}
		}

		if ($field.attr('name') === 'PARAM_EMAIL') {
			if (checkFieldLength($field, MIN_LENGTH_EMAIL, MAX_LENGTH_EMAIL) && customEmailValidation($field.val())) {
				checkUniqueEmail($field).done((data) => {
					if (data.status === 'SUCCESS') {
						markValid($field);
						fieldValid = true;
					} else {
						markInvalid($field);
					}
					resolve(fieldValid);
				});
			} else {
				markInvalid($field);
				resolve(fieldValid);
			}
		}

		if ($field.attr('name') === 'PARAM_USR_PASS') {
			if (checkFieldLength($field, MIN_LENGTH_PASSWORD, MAX_LENGTH_PASSWORD) && notOnlyLetters($field.val())) {
				if ($field.val() === $signUpBasicForm.find('input[name="PARAM_USR_NAME"]').val()) {
					markInvalid($field, 'same-username-error');
				} else {
					markValid($field);
					fieldValid = true;
				}
			} else {
				markInvalid($field);
			}
			resolve(fieldValid);
		}

		// validate first and last name
		if ($field.attr('name') === 'PARAM_FIRST_NAME' || $field.attr('name') === 'PARAM_SURNAME') {
			if (checkFieldLength($field, MIN_LENGTH_NAMES, MAX_LENGTH_NAMES) && isOnlyLettersSpacesDashes($field.val())) {
				markValid($field);
				fieldValid = true;
			} else {
				markInvalid($field);
			}
			resolve(fieldValid);
		}

		if ($field.attr('name') === 'personalnumber') {
			if (checkFieldLength($field, 11, 11) && isOnlyNumbers($field.val()) && pesel.isValid($field.val())) {
				pesel.checkPeselFromServer($field.val())
					.then((response) => {
						if (response.status === 'SUCCESS') {
							markValid($field);
							fieldValid = true;
						} else {
							const $inputParent = $($field).parent();

							$inputParent.data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE, response.errorDescription);
							markInvalid($field);
							$inputParent.removeData(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE);
						}
						resolve(fieldValid);
					});
			} else {
				markInvalid($field);
				resolve(fieldValid);
			}
		}

		if ($field.attr('name') === 'PARAM_ADDRESS1') {
			if (checkFieldLength($field, MIN_LENGTH_ADDRESS, MAX_LENGTH_ADDRESS) && isSpacesValid($field.val())) {
				markValid($field);
				fieldValid = true;
			} else {
				markInvalid($field);
			}
			resolve(fieldValid);
		}
		if ($field.attr('name') === 'PARAM_POST_CODE') {
			// length rules are the same as first and last name
			if (checkFieldLength($field, MIN_LENGTH_NAMES, MAX_LENGTH_NAMES) && isSpacesValid($field.val())) {
				markValid($field);
				fieldValid = true;
			} else {
				markInvalid($field);
			}
			resolve(fieldValid);
		}
		if ($field.attr('name') === 'PARAM_CITY') {
			if (checkFieldLength($field, MIN_LENGTH_CITY, MAX_LENGTH_CITY) && isOnlyLettersSpacesDashes($field.val())) {
				markValid($field);
				fieldValid = true;
			} else {
				markInvalid($field);
			}
			resolve(fieldValid);
		}
		if ($field.attr('name') === 'PARAM_GENDER') {
			if ($field.val() !== 0 && !isNaN(Number($field.val()))) {
				fieldValid = isGenderValid($field);
			}
			resolve(fieldValid);
		}
		if ($field.attr('name') === 'PARAM_CALLING_CODE') {
			if (!isNaN($field.val())) {
				if ($PhNumber.val() !== '' && currentMobile && currentMobile !== getMobileNumber($field, $PhNumber)) {
					checkUniquePhoneNumber($field, $PhNumber).done((data) => {
						if (data.status === 'SUCCESS') {
							markValid($PhNumber);
							markValid($field);
							fieldValid = true;
						} else {
							markInvalid($field);
						}
						resolve(fieldValid);
					});
				} else {
					markValid($field);
					fieldValid = true;
					resolve(fieldValid);
				}
			} else {
				markInvalid($field);
				resolve(fieldValid);
			}
		}
		if ($field.attr('name') === 'PARAM_PH_NUMBER') {
			if (!isNaN($field.val())) {
				if ($callingCode.val() !== '' && currentMobile !== getMobileNumber($callingCode, $field)) {
					checkUniquePhoneNumber($callingCode, $field).done((data) => {
						if (data.status === 'SUCCESS') {
							markValid($callingCode);
							markValid($field);
							fieldValid = true;
						} else {
							markInvalid($field);
						}
						resolve(fieldValid);
					});
				} else {
					markValid($field);
					fieldValid = true;
					resolve(fieldValid);
				}
			} else {
				markInvalid($field);
				resolve(fieldValid);
			}
		}
		if ($field.attr('name') === 'PARAM_BONUS_CODE') {
			// TODO is there any validation here?
			if (!$field.val()) {
				markValid($field);
				fieldValid = true;
			}
			resolve(fieldValid);
		}
	});
}

function setupFocusOutHandlersForFirstStep() {
	function isValid() {
		if (isFirstStepFormValid()) {
			enableContinueButton();
		} else {
			disableContinueButton();
		}
	}

	function callback() {
		const $field = $(this);
		$field.parent().removeData('content-dynamic-error');

		if ($field.val() !== '') {
			validate($field).then(() => {
				isValid();
			});
		} else {
			markInvalid($(this));
			isValid();
		}
	}

	const instance = new Intent();
	const $inputs = $signUpBasicForm.find('input');

	$inputs.on('input.signUpBasic focusout.signUpBasic', (e) => {
		if (e.type === 'focusout') {
			instance.clear();
			callback.call(e.currentTarget);
		} else {
			instance.exec(callback.bind(e.currentTarget));
		}
	});

	$inputs.each((i, field) => {
		if (field.value.length > 0) {
			callback.call(field);
		}
	});
}

function checkValidationSecondStep() {
	if (isSecondStepFormValid()) {
		populatePlayerObject();
		enableOpenAccountButton();
	} else {
		disableOpenAccountButton();
	}
}

function setupFocusOutHandlersForSecondStep() {
	function callback() {
		const $field = $(this);
		const isRequired = $field.attr('required');
		if ($field.val() !== '') {
			validate($field).then(() => {
				checkValidationSecondStep();
			});
		} else if (isRequired) {
			markInvalid($field);
			checkValidationSecondStep();
		} else {
			checkValidationSecondStep();
		}
	}
	const instance = new Intent();
	$signUpDetailsForm.find('input').on('input.signUpDetails focusout.signUpDetails', (e) => {
		if (e.type === 'focusout') {
			instance.clear();
			callback.call(e.currentTarget);
		} else {
			instance.exec(callback.bind(e.currentTarget));
		}
	});
}

function allowedAgeToPlay(isoCode) {
	// returns 21 for Estonia
	return isoCode === 'ee' ? 21 : 18;
}

function maxYearAllowed(isoCode) {
	const allowedAge = allowedAgeToPlay(isoCode);
	return currentYear - allowedAge;
}

function maxMonthAllowed(yearSelected, isoCode) {
	const allowedAge = allowedAgeToPlay(isoCode);
	if (yearSelected === currentYear - allowedAge) {
		$signUpDetailsForm.find('select[name=PARAM_DAY]').parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
		$signUpDetailsForm.find('select[name=PARAM_MONTH]').parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
		$signUpDetailsForm.find('select[name=PARAM_YEAR]').parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
		return currentMonth;
	}
	return 12;
}

function maxDayAllowed(monthSelected, yearSelected, isoCode) {
	if (isoCode === 'ee') {
		if ((yearSelected === currentYear - 21) && monthSelected === currentMonth) {
			return currentDay;
		}
		return 31;
	}
	if ((yearSelected === currentYear - 18) && monthSelected === currentMonth) {
		return currentDay;
	}
	return 31;
}

function onChangeDateOfBirth() {
	$birthDate.find('select').change(() => {
		getDateOfBirthValues();
	});
}

function getDateOfBirthValues() {
	const $yearField = $birthDate.find('select[name=PARAM_YEAR]');
	const $monthField = $birthDate.find('select[name=PARAM_MONTH]');
	const $dayField = $birthDate.find('select[name=PARAM_DAY]');
	const yearSelected = Number($birthDate.find('select[name=PARAM_YEAR] option:selected').text());
	const monthSelected = Number($birthDate.find('select[name=PARAM_MONTH] option:selected').text());
	const daySelected = Number($birthDate.find('select[name=PARAM_DAY] option:selected').text());
	let isLeap;

	if (countryIsoCode === '' || countryIsoCode === '**') {
		countryIsoCode = 'se';
	}

	if (!isNaN(yearSelected) && !isNaN(monthSelected) && !isNaN(daySelected)) {
		if (yearSelected > maxYearAllowed(countryIsoCode)) {
			markInvalid($yearField);
		} else if (monthSelected > maxMonthAllowed(yearSelected, countryIsoCode)) {
			markInvalid($monthField);
		} else if (daySelected > maxDayAllowed(monthSelected, yearSelected, countryIsoCode)) {
			markInvalid($dayField);
		} else if ((monthSelected === 4 || monthSelected === 6 || monthSelected === 9 || monthSelected === 11) && daySelected === 31) {
			markInvalid($dayField);
		} else if (monthSelected === 2) {
			isLeap = (yearSelected % 4 === 0 && (yearSelected % 100 !== 0 || yearSelected % 400 === 0));
			if (daySelected > 29 || (daySelected === 29 && !isLeap)) {
				markInvalid($dayField);
			} else {
				selectedValues.year = $yearField.val();
				selectedValues.month = $monthField.val();
				selectedValues.day = $dayField.val();
				Cookies.set('registrationStepTwo', JSON.stringify(selectedValues));
				markValid($yearField);
				markValid($monthField);
				markValid($dayField);
			}
		} else {
			selectedValues.year = $yearField.val();
			selectedValues.month = $monthField.val();
			selectedValues.day = $dayField.val();
			Cookies.set('registrationStepTwo', JSON.stringify(selectedValues));
			markValid($yearField);
			markValid($monthField);
			markValid($dayField);
		}
	} else {
		markInvalid($yearField);
		markInvalid($monthField);
		markInvalid($dayField);
	}
	checkValidationSecondStep();
}

function onChangeGenderHandler() {
	$gender.find('select').change(function nameToBeLintvalid2() {
		validateGender($(this));
	});

	// Not sure where else to put this. Checks if the value has been loaded and validates it.
	if ($gender.find('select[name="PARAM_GENDER"] option:selected').val() !== 0) {
		validateGender($gender.find('select[name="PARAM_GENDER"]'));
	}
}

function validateGender($genderSelected) {
	isGenderValid($genderSelected);
	checkValidationSecondStep();
}

function onChangeLocalization() {
	$localization.find('select').change(() => {
		getLocalizationValues();
	});
}

function getLocalizationValues(check) {
	const $countrySelected = $localization.find('select[name=PARAM_COUNTRY]');
	const $currencySelected = $localization.find('select[name=PARAM_CURRENCY]');
	let countryValid = false;
	let currencyValid = false;

	if ($countrySelected.val() !== '0' && $countrySelected.val().length === 2) {
		countryValid = true;
		selectedValues.country = $countrySelected.val();
		Cookies.set('registrationStepTwo', JSON.stringify(selectedValues));
		markValid($countrySelected);
	} else {
		markInvalid($countrySelected);
	}
	if ($currencySelected.val() !== '0' && $currencySelected.val().length === 3) {
		currencyValid = true;
		selectedValues.currency = $currencySelected.val();
		Cookies.set('registrationStepTwo', JSON.stringify(selectedValues));
		markValid($currencySelected);
	} else {
		markInvalid($currencySelected);
	}
	if (countryValid && currencyValid) {
		checkValidationSecondStep();
	}
}

function addOptionsToArray(array, value, textToDisplay, selectedFlag) {
	const opt = document.createElement('option');
	opt.value = opt.innerHTML = value;
	if (textToDisplay) {
		opt.innerHTML = textToDisplay;
	}
	if (selectedFlag) {
		opt.selected = true;
	}
	array.push(opt);
}

function populateCountries(listOfCountries) {
	const countriesArray = [];
	const $countrySelect = $signUpDetailsForm.find('#countries-holder');
	let i;
	let validateValues = false;

	if (Cookies.get('registrationStepTwo')) {
		selectedValues = JSON.parse(Cookies.get('registrationStepTwo'));
		validateValues = true;
	}

	for (i = 0; i < listOfCountries.length; i += 1) {
		if (selectedValues.country) {
			addOptionsToArray(countriesArray, listOfCountries[i].countryCode, listOfCountries[i].text, selectedValues.country === listOfCountries[i].countryCode);
		} else {
			addOptionsToArray(countriesArray, listOfCountries[i].countryCode, listOfCountries[i].text, listOfCountries[i].selected);
		}
	}

	$countrySelect.html('');

	// Append values
	$countrySelect.append(countriesArray);

	if (validateValues && $signUpDetailsForm.find('#currency-holder').length > 1) {
		getLocalizationValues();
	}
}

function populateCurrencies(listOfCurrencies) {
	const currenciesArray = [];
	const $currencySelect = $signUpDetailsForm.find('#currency-holder');
	let i;
	let validateValues = false;

	if (Cookies.get('registrationStepTwo')) {
		selectedValues = JSON.parse(Cookies.get('registrationStepTwo'));
		validateValues = true;
	}

	for (i = 0; i < listOfCurrencies.length; i += 1) {
		if (selectedValues.currency) {
			addOptionsToArray(currenciesArray, listOfCurrencies[i].text, false, selectedValues.currency === listOfCurrencies[i].text);
		} else {
			addOptionsToArray(currenciesArray, listOfCurrencies[i].text, false, listOfCurrencies[i].selected);
		}
	}

	$currencySelect.html('');

	// Append values
	$currencySelect.append(currenciesArray);
	if (validateValues && $signUpDetailsForm.find('#countries-holder').length > 1) {
		getLocalizationValues();
	}
}

function populateCountryCodeIfEnabled(callingcode, isBlacklisted) {
	$countryCodeField.attr('placeholder', callingcode);
	if (isBlacklisted) { //TODO needed or fixed by disableCountryCallingCode?
		//Blacklisted countries shouldn't be able to edit.
		disableCountryCallingCode();
	}
	$countryCodeField.val(callingcode);
	$countryCodeField.addClass(VALID_CLASS);
}

function disableCountryCallingCode() {
	$countryCodeField.attr('disabled', 'disabled');
	$localization.find('input[name=PARAM_CALLING_CODE]').parent().addClass('custom-select--disabled');
	$localization.find('input[name=PARAM_CALLING_CODE]').attr('disabled', 'disabled');
}

function disableCountrySelection() {
	$countryCodeField.attr('disabled', 'disabled');
	$localization.find('select[name=PARAM_COUNTRY]').parent().addClass('custom-select--disabled');
	$localization.find('select[name=PARAM_COUNTRY]').attr('disabled', 'disabled');
}

/* function addOptionsToArrayWithSameKayValue(array, value) {
	var opt = document.createElement('option');
	opt.value = opt.innerHTML = value;
	array.push(opt);
	}*/

function setupDateLimits() {


	const maxYear = maxYearAllowed(countryIsoCode);
	const minYear = 1900
	const $yearField = $birthDate.find('select[name=PARAM_YEAR]');
	const $monthField = $birthDate.find('select[name=PARAM_MONTH]');
	const $dayField = $birthDate.find('select[name=PARAM_DAY]');

	const yearsArray = [];
	const monthsArray = [];
	const daysArray = [];
	let i;
	let validateValues = false;

	if (Cookies.get('registrationStepTwo')) {
		selectedValues = JSON.parse(Cookies.get('registrationStepTwo'));
		validateValues = true;
	}

	// populate year, month and day lists
	for (i = maxYear; i >= minYear; i -= 1) {
		addOptionsToArray(yearsArray, i, null, parseInt(selectedValues.year, 10) === i);
	}
	for (i = 1; i < 13; i += 1) {
		addOptionsToArray(monthsArray, i, null, parseInt(selectedValues.month, 10) === i);
	}
	for (i = 1; i < 32; i += 1) {
		addOptionsToArray(daysArray, i, null, parseInt(selectedValues.day, 10) === i);
	}

	// Append values
	$yearField.append(yearsArray);
	$monthField.append(monthsArray);
	$dayField.append(daysArray);

	if (validateValues) {
		getDateOfBirthValues();
	}
}

function tryRegisterNewUser(playerIn) {
	console.log('Trying to register');
	console.log(playerIn);
	// noinspection JSDuplicatedDeclaration
	const newPlayer = playerIn;
	newPlayer.phoneNumber = adjustPhoneNumber(newPlayer.phoneNumber);
	// $phoneNumber = $($phone).find('input[name=PARAM_PH_NUMBER]'),

	spinner.show($signUpDetails);
	disableOpenAccountButton();

	const tryRegisterNewUserPromise = $.ajax({
		async: true,
		type: 'PUT',
		url: '/rest/register/player/',
		data: JSON.stringify(newPlayer),
		dataType: 'json',
		contentType: 'application/json; charset=utf-8'
	}).done((data) => {
		// const timetoshowresult = 1000; // 1 Second
		if (data.status === 'SUCCESS' && data.result) {
			const title = ((data.result.map && data.result.map.title) || null);
			const message = ((data.result.map && data.result.map.message) || null);
			/* the notification is not directly controlled from here, since it gets overly complex to keep track of the
			mix of timers, global overlaying elements, navigation routing, notifications-module used by many modules and asynchrononus calls.
			The notifications module is therefore extended (temporarily) to keep the information and access it later. /Sunny jan 2017*/
			// notifications.showInformationMessage('success', data.result.map.title, data.result.map.message, null, timetoshowresult);
			notifications.storeInfo({
				posting: 'signup-validation',
				type: 'success',
				success: true,
				message,
				title
			});
			login.changeHeaderIcon();
			Cookies.set('sessionId', data.result.map.sessionKey, { domain: rootDomain() });
			accountInfo.getPlayerInfo();
			accountInfo.getPlayerBalance();
			accountInfo.getPlayerPoints();
			pixelTracking.push('fullReg');
			replace('/account/deposit/bonus?referrer=register');
		} else {
			// TODO Error Handling

			console.error('Signup failed!');

			// Mobile number PLAYER_EXCEPTION_MOBILE_FORMAT_ERROR, PLAYER_EXCEPTION_MOBILE_INVALID_BY_TELESIGN, PLAYER_EXCEPTION_PHONE_EXIST,
			// Country PLAYER_EXCEPTION_INVALID_COUNTRY, PLAYER_EXCEPTION_COUNTRY_STATE_WRONG
			// Currency PLAYER_EXCEPTION_INVALID_CURRENCY

			// PLAYER_EXCEPTION_VALIDATION_ERROR_FIRST_NAME
			// PLAYER_EXCEPTION_VALIDATION_ERROR_LASTNAME
			// PLAYER_EXCEPTION_ESTONIAN_UNDER_AGE
			// PLAYER_EXCEPTION_UNDER_AGE
			// PLAYER_EXCEPTION_PLAYER_EXCEPTION_LEAP_SHORT_MONTH
			// PLAYER_EXCEPTION_VALIDATION_ERROR_GENDER
			// PLAYER_EXCEPTION_VALIDATION_ERROR_ADDRESS1
			// PLAYER_EXCEPTION_VALIDATION_ERROR_POST_CODE
			// PLAYER_EXCEPTION_VALIDATION_ERROR_CITY
			// PLAYER_EXCEPTION_VALIDATION_MOBILE_PHONE_COUNTRY_CODE
			// PLAYER_EXCEPTION_VALIDATION_ERROR_NOT_ALLOWED_COUNTRY

			// Add this ones? PLAYER_EXCEPTION_DUPLICATE_PLAYERS_UK_EXISTS,

			// $phone.removeClass(VALID_CLASS).addClass(ERROR_CLASS);
			// $phone.data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE, data.errorDescription);
			notifications.showNotification(`${data.errorDescription}`, 'red', true);
		}
	}).fail((jqXHR, textStatus, errorThrown) => {
		console.error(jqXHR, textStatus, errorThrown);
		const continueButton = document.getElementsByClassName('js-registration-continue-button');
		notifications.showNotification(continueButton[0].getAttribute('data-error-message-ajax-failure'), 'red', true);
	}).always(() => {
		spinner.hide($signUp);
		enableContinueButton();
	});

	return tryRegisterNewUserPromise;
}

/**
 * ajax call that will save data in unregistered_players
 * @param player, object with player data
 */
function saveUserData(p) {
	const saveThis = {
		username: p.username,
		password: p.password,
		email: p.email
	};

	$.ajax({
		async: true,
		type: 'POST',
		url: '/rest/register/token/',
		data: JSON.stringify(saveThis),
		dataType: 'json',
		contentType: 'application/json; charset=utf-8'
	}).done((data) => {
		if (data.status === 'SUCCESS') {
			// what to do here?
			console.info('SaveUserData succeeded!');
			//Save to cookies as well in case we need to restore these values again.
			Cookies.set('registrationStepOne', JSON.stringify({ username: p.username, password: p.password, email: p.email }));
		} else {
			console.error('SaveUserData failed!');
		}
	}).fail((jqXHR, textStatus, errorThrown) => {
		console.error(jqXHR, textStatus, errorThrown);
		console.error('SaveUserData call failed!');
	});
}

/**
 * will call checkUnique functions to validate fields server side and it will wait for the promise to resolve.
 * @param handleSuccess, success callback
 * @param handleFail, fail callback
 */
function validationsServerSideForStepOne(handleSuccess, handleFail, handleAlways) {
	const $username = $signUpBasicForm.find('input[name="PARAM_USR_NAME"]');
	const $email = $signUpBasicForm.find('input[name="PARAM_EMAIL"]');
	const $pass = $signUpBasicForm.find('input[name="PARAM_USR_PASS"]');

	// it waits for both promises before executing function,
	$.when(checkUniqueUsername($username), checkUniqueEmail($email), $pass).done((args1, args2) => {
		// args1 and args2 are arguments resolved for the usernameValid and emailValid ajax requests, respectively.
		// Each argument is an array with the following structure: [ data, statusText, jqXHR ]
		if (args1[0].status === 'SUCCESS' && args2[0].status === 'SUCCESS') {
			// username and email are set inside the ajax call response, if both are success we add the password to player object
			player[$pass.attr('map')] = $pass.val();
			saveUserData(player);
			handleSuccess();
		} else {
			handleFail();
			disableContinueButton();
		}
	}).always(() => {
		if (handleAlways) {
			handleAlways();
		}
	});
}

/**
 *
 * @param handleSuccess, success callback
 * @param handleFail, fail callback
 */
function validationsServerSideForStepTwo(handleSuccess, handleFail, handleAlways) {
	// Will do only one call with the new player info and return an error on the first field failing if any (skip the others)
	$.when(tryRegisterNewUser(player)).done((args) => {
		// args is an array with the following structure: [ data, statusText, jqXHR ]
		if (args.status === 'SUCCESS') {
			handleSuccess();
		} else {
			// markFailingField()
			handleFail();
			disableContinueButton();
		}
	}).always(() => {
		if (handleAlways) {
			handleAlways();
		}
	});
}

function setUpVoucherTogglerClick() {
	$voucher.find('.js-voucher__link').on('click', function nameToBeLintvalid3(event) {
		const $voucherField = $(this).next();
		event.preventDefault();
		$voucher.toggleClass('accordion--is-open');
		$voucherField.toggleClass('u-hide');
	});
}

function countryCodeValidator() {
	$countryCodeField.on('input', function nameToBeLintvalid4() {
		if (this.value.length > MAX_LENGTH_COUNTRY_CODE) {
			this.value = this.value.slice(0, MAX_LENGTH_COUNTRY_CODE);
		}
		checkValidationSecondStep();
	});
}

function markDefaultOptionsAsValid() {
	const $countrySelected = $localization.find('select[name=PARAM_COUNTRY]');
	const $currencySelected = $localization.find('select[name=PARAM_CURRENCY]');

	if ($countrySelected.val() !== '0' && $countrySelected.val().length === 2) {
		markValid($countrySelected);
	}

	if ($currencySelected.val() !== '0' && $currencySelected.val().length === 3) {
		markValid($currencySelected);
	}
}

function getInfoAndPopulateLists() {
	fetchJson('/geoip').then((geoipData) => {
		const geoipResult = JSON.parse(geoipData.result);
		if (geoipData.status === 'SUCCESS') {
			const countryCode = geoipResult.countryCode;

			fetchJson(`/registerbox/?countryCode=${countryCode}`).then((registerboxData) => {
				let countries = {};
				let currencies = {};
				const mapping = registerboxData.result.map;
				if (registerboxData.status === 'SUCCESS') {
					countries = mapping.countries.list;
					currencies = mapping.currencies.list;
					populateCountries(countries);
					populateCurrencies(currencies);
					populateCountryCodeIfEnabled(mapping.callingcode.integer);
					markDefaultOptionsAsValid();
					//Disable calling code and country if blacklisted.
					if (mapping.disablecountrycallingcode.value) {
						disableCountryCallingCode();
						disableCountrySelection();
					}
				} else {
					console.error('Error getting registerbox data in getInfoAndPopulateLists');
				}
			});
		} else {
			console.error('Error getting registerbox data in getInfoAndPopulateLists');
		}
	});
}

function setupFormSelectors(signUp) {
	// var $boxes = signUpAccount.$box.parent();
	$signUpBasic = signUp.find('.signup-basic');
	$signUpDetails = signUp.find('.signup-details');
	$signUpBasicForm = $signUpBasic.find('form');
	$signUpDetailsForm = $signUpDetails.find('form');
	$birthDate = $signUpDetailsForm.find('#birthdate-wrapper-id');
	$gender = $signUpDetailsForm.find('#gender-wrapper-id');
	$countryCodeField = $signUpDetailsForm.find('input[name=PARAM_CALLING_CODE]');
	$localization = $signUpDetailsForm.find('#localization-wrapper-id');
	$voucher = $signUpDetailsForm.find('#voucher-wrapper-id');
	$PhNumber = $signUpDetailsForm.find('input[name="PARAM_PH_NUMBER"]');
	$callingCode = $signUpDetailsForm.find('input[name="PARAM_CALLING_CODE"]');
}

function setUpValidationsStep1() {
	// First step
	setupFocusOutHandlersForFirstStep();
}

function setUpValidationsStep2() {
	// Second step
	setupFocusOutHandlersForSecondStep();
	onChangeDateOfBirth();
	onChangeGenderHandler();
	onChangeLocalization();
	setupDateLimits();
	setUpVoucherTogglerClick();
	countryCodeValidator();
}

function setupValidation(signUp) {
	$signUp = signUp;
	setupFormSelectors($signUp);
	setUpValidationsStep1();
	setUpValidationsStep2();
	togglePassword.setupInForm($signUpBasicForm);
}

function isMobileVerificationValid() {
	return $mobileVerification.find('input').length === $mobileVerification.find(`input.${VALID_CLASS}`).length &&
		(currentMobile !== getMobileNumber($callingCode, $PhNumber) || !isMobileVerified);
}

function setupFocusOutHandlersForMobileVerification() {
	$mobileVerification = $('.js-verify-phone--step-1');
	const $fields = $mobileVerification.find('input');

	function callback() {
		const $field = $(this);
		const isRequired = $field.attr('required');

		function isValid() {
			if (isMobileVerificationValid()) {
				$mobileVerificationButton.attr('disabled', false);
			} else {
				$mobileVerificationButton.attr('disabled', true);
			}
		}

		if ($field.val() !== '') {
			validate($field).then(() => {
				isValid();
			});
		} else if (isRequired) {
			markInvalid($field);
			isValid();
		} else {
			isValid();
		}
	}

	const instance = new Intent();

	$fields.on('input.mobileVerification focusout.mobileVerification', (e) => {
		if (e.type === 'focusout') {
			instance.clear();
			callback.call(e.currentTarget);
		} else {
			instance.exec(callback.bind(e.currentTarget));
		}
	});
}

function setupFocusOutHandlersForCodeVerification() {
	const $verifyCode = $('.js-verify_code');
	const $verifyCodeButton = $verifyCode.find('.js-verifymobile');

	$verifyCode.find('#new-code').on('input.mobileVerification', (e) => {
		const $field = $(e.currentTarget);

		if (/^[0-9]{6}$/.test($field.val())) {
			markValid($field);
			$verifyCodeButton.attr('disabled', false);
		} else {
			markInvalid($field);
			$verifyCodeButton.attr('disabled', true);
		}
	});
}

function setupMobileValidation() {
	accountInfo.getPlayerInfo().done((resultData) => {
		if (resultData.status === 'SUCCESS') {
			$mobileVerification = $('.js-verify-phone--step-1');
			$mobileVerificationButton = $mobileVerification.find('.js-verify-get-code');
			$PhNumber = $mobileVerification.find('#new-phone');
			$callingCode = $mobileVerification.find('#new-phone-cc');
			currentMobile = `${resultData.result.mobileCountryCode}${resultData.result.mobile}`;
			isMobileVerified = resultData.result.playerVerificationsVO.mobileStatus;
			setupFocusOutHandlersForMobileVerification();
			setupFocusOutHandlersForCodeVerification();
		}

		if (resultData.status === 'FAILURE') {
			console.error(`${resultData.errorDescription}. Code: ${resultData.errorCode}`);
		}
	});
}

function resetRegisterForm() {
	resetSignupBasicForm();
	resetSignupDetailForm();
	//we do this so that the next time register is opened, we get pre-selected country+currency+country_code
	getInfoAndPopulateLists();
	//and we mark them as valid
	markValid($countryCodeField);
	$signUpDetailsForm.find('#signup-voucher').addClass('is-valid');
	$signUpDetailsForm.find('#states-holder').addClass('is-valid');
	markDefaultOptionsAsValid();
	//we make sure the open account button is disabled on page load
	checkValidationSecondStep();
}

function resetSignupBasicForm() {
	if ($signUpBasicForm && $signUpBasicForm[0] && $signUpBasicForm[0].reset) {
		$signUpBasicForm[0].reset();
	}

	$signUpBasicForm.find('input').each((i, e) => {
		$(e).removeClass('is-valid');
	});

	disableContinueButton();
}

function resetSignupDetailForm() {
	if ($signUpDetailsForm && $signUpDetailsForm[0] && $signUpDetailsForm[0].reset) {
		$signUpDetailsForm[0].reset();
	}

	//we have to get rid of valid classes in case the form is re-opened without being re-created
	$signUpDetailsForm.find('input').each((i,e) => {
		$(e).removeClass('is-valid');
	});

	$signUpDetailsForm.find('select').each((i,e) => {
		$(e).removeClass('is-valid');
	});
}

const api = {
	setupValidation,
	isFirstStepFormValid,
	isSecondStepFormValid,
	validationsServerSideForStepOne,
	validationsServerSideForStepTwo,
	getInfoAndPopulateLists,
	setupMobileValidation,
	resetRegisterForm
};

export default api;



// WEBPACK FOOTER //
// ./mobile-core/src/register/signup-validation.js